import { useEffect, useState } from "react";
import { useFormikContext } from "formik";
import { useGetFahrzeug } from "../client/hooks";

interface UseTtbExternLademengeProps {
  index: number;
  materialTransportIndex: number;
  fahrzeugId: string;
  materialtransport: any;
  type: "materialanfuhr" | "materialtransport" | "materialabtransport";
}

export const useTtbExternLademenge = ({
  index,
  materialTransportIndex,
  fahrzeugId,
  materialtransport,
  type,
}: UseTtbExternLademengeProps) => {
  const { setFieldValue } = useFormikContext();
  const [currentFahrzeugLadeMenge, setCurrentFahrzeugLadeMenge] =
    useState<number>(0);
  const getfahrzeug = useGetFahrzeug();
  const [fahrzeugIdHasChanged, setFahrzeugIdHasChanged] =
    useState<boolean>(false);
  const [initialFahrzeugId] = useState<string | null>(fahrzeugId);

  useEffect(() => {
    const fetchData = async () => {
      if (fahrzeugId !== initialFahrzeugId) {
        setFahrzeugIdHasChanged(true);
      }
      const data = await getfahrzeug(fahrzeugId);

      if (materialtransport.id && fahrzeugIdHasChanged) {
        await setFieldValue(
          `fuhrparkeintraege.${index}.${type}.${materialTransportIndex}.menge`,
          data.ladeMenge ?? 0
        );
        setCurrentFahrzeugLadeMenge(data.ladeMenge ?? 0);
      } else if (!materialtransport.id) {
        await setFieldValue(
          `fuhrparkeintraege.${index}.${type}.${materialTransportIndex}.menge`,
          data.ladeMenge ?? 0
        );
        setCurrentFahrzeugLadeMenge(data.ladeMenge ?? 0);
      }
    };

    fetchData();
  }, [fahrzeugId]);

  return currentFahrzeugLadeMenge;
};
